import { useState } from 'react';

/*
 * Заставка окна входа — тот же паттерн, что подложкой в чате.
 *
 * Рисунок лежит в маске, цвет приходит из токена --chat-ink, поэтому обе темы
 * берут один файл и вход звучит так же, как лента сообщений.
 *
 * Сам рисунок неподвижен. Живёт плотность: по листу в случайных местах
 * вспыхивают и гаснут пятна света, каждое в своём ритме (Илья, 07.09.2026:
 * не волна и не движение иконок, а хаотичные пульсации). Когда пятно
 * погасло, оно перепрыгивает на новое случайное место — прыжок невидим,
 * потому что происходит при нулевой прозрачности. Период и задержка у пятна
 * постоянны: смена длительности на ходу сдвигает фазу анимации, и пятно
 * вспыхивает рывком (так было в первой версии — Илья, 07.09.2026: «плавнее»).
 * Анимируются только opacity и transform, кадры собирает композитор.
 *
 * Стили — в styles.css (.login-backdrop, .login-glow), prefers-reduced-motion останавливает.
 */

const GLOWS = 7;

type Glow = { x: number; y: number; t: number; d: number };

const place = (g?: Glow): Glow => ({
  x: 5 + Math.random() * 90,
  y: 5 + Math.random() * 90,
  // период 7–12 с и задержка задаются один раз, чтобы пятна не вспыхивали хором
  t: g ? g.t : 7 + Math.random() * 5,
  d: g ? g.d : Math.random() * 8,
});

export function LoginBackdrop() {
  const [glows, setGlows] = useState<Glow[]>(() => Array.from({ length: GLOWS }, () => place()));

  const move = (i: number) =>
    setGlows((prev) => prev.map((g, k) => (k === i ? place(g) : g)));

  return (
    <div className="login-backdrop" aria-hidden="true">
      {glows.map((g, i) => (
        <i
          key={i}
          className="login-glow"
          style={{ left: `${g.x}%`, top: `${g.y}%`, animationDuration: `${g.t}s`, animationDelay: `${g.d}s` }}
          onAnimationIteration={() => move(i)}
        />
      ))}
    </div>
  );
}
